import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges, ViewChild } from "@angular/core";
import { MeasurementManager } from "src/app/shared/models/clinic-history/growth-measurements.model";

@Component({
  selector: 'app-growth-chart-doctor-select',
  templateUrl: './growth-chart-doctor-select.component.html',
  styleUrls: ['./growth-chart-doctor-select.component.css']
})
export class GrowthChartsDoctorSelectComponent implements OnChanges {

    isDropdownOpen = false;
    selectedDoctor: MeasurementManager | null = null;
 
    @Input() measurementManager: MeasurementManager[] = [];
    @Output() doctorSelected = new EventEmitter<number>();
    @ViewChild('customSelect') customSelect: ElementRef;

    @HostListener('document:click', ['$event'])
    clickOutside(event: Event) {
        if (!this.customSelect?.nativeElement.contains(event.target)) {
            this.isDropdownOpen = false;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.measurementManager && this.measurementManager.length) {
            this.selectedDoctor = this.measurementManager[0];
        }
    }

    selectDoctor(doctor: MeasurementManager | null) {
        this.doctorSelected.emit(doctor?.id ?? 0);
        this.isDropdownOpen = false;
        this.selectedDoctor = doctor;
    }

    toggleDropdown(event: Event) {
        event.stopPropagation(); 
        this.isDropdownOpen = !this.isDropdownOpen;
    }

}